<template>
  <v-card>
    <v-card-title>{{ $t('Dashboard.Presets.newPreset') }}</v-card-title>
    <v-card-text>
      <v-text-field v-model="name" :label="$t('Dashboard.Presets.name')"></v-text-field>
      <v-text-field v-model="description" :label="$t('Dashboard.Presets.description')"></v-text-field>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="create" text color="primary" :disabled="!name">{{ $t('Global.Action.create') }}</v-btn>
    </v-card-actions>
  </v-card> 
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'DashboardPresetsNew',
  data: () => ({
    name: '',
    description: ''
  }),
  methods: {
    ...mapActions('dashboard', [
      'addPreset'
    ]),
    async create() {
      await this.addPreset(({
        name: this.name,
        description: this.description
      }))
      this.$emit('created')
      this.name = ''
      this.description = ''
    }
  }
}
</script>

<style>

</style>